import { render } from "./FilmsEditor.vue?vue&type=template&id=16ab27f8&scoped=true"
import script from "./FilmsEditor.vue?vue&type=script&lang=js"
export * from "./FilmsEditor.vue?vue&type=script&lang=js"

import "./FilmsEditor.vue?vue&type=style&index=0&id=16ab27f8&lang=scss&scoped=true"

import exportComponent from "D:\\main\\spacelab\\cinema-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16ab27f8"]])

export default __exports__